import React, { createContext, useContext, useState, useCallback } from 'react';
import en from './en';
import km from './km';

const TRANSLATIONS = { en, km };
const STORAGE_KEY = 'erp_language';

const LangContext = createContext(null);

export const LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English', flag: '🇺🇸' },
  { code: 'km', label: 'Khmer', nativeLabel: 'ភាសាខ្មែរ', flag: '🇰🇭' },
];

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored && TRANSLATIONS[stored] ? stored : 'en';
  });

  const setLang = useCallback((code) => {
    if (!TRANSLATIONS[code]) return;
    localStorage.setItem(STORAGE_KEY, code);
    setLangState(code);
  }, []);

  // t('nav.dashboard') → looks up translations[lang].nav.dashboard
  // Supports {{var}} interpolation: t('orders.itemsCount', { n: 5 })
  const t = useCallback((key, vars) => {
    const parts = key.split('.');
    let val = TRANSLATIONS[lang];
    for (const p of parts) {
      if (val == null) break;
      val = val[p];
    }
    // Fallback to English if key not found in current lang
    if (val == null) {
      val = TRANSLATIONS['en'];
      for (const p of parts) {
        if (val == null) break;
        val = val[p];
      }
    }
    if (typeof val !== 'string') return key;
    if (!vars) return val;
    return val.replace(/\{\{(\w+)\}\}/g, (_, k) => vars[k] ?? `{{${k}}}`);
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used inside LangProvider');
  return ctx;
};
